export const DUT_QA_OPERATION_MODE = 5;

interface DutQaClassification {
  isDutQA?: boolean | null;
}

export function isDutQaOperationMode(operationMode?: number | null): boolean {
  return operationMode === DUT_QA_OPERATION_MODE;
}

// A classificação vem do backend (operation_mode da telemetria); leituras de CO2/umidade não definem se o DUT é QA.
export function isDutQa(dev: Readonly<DutQaClassification>): boolean {
  return dev.isDutQA === true;
}

// A flag HIDE_DUT_QA_TEMP vale só para DUT QA: DUT de referência ou automação continua exibindo temperatura.
export function shouldHideDutQaTemperature(dev: Readonly<DutQaClassification>, hideTemp: boolean): boolean {
  return hideTemp && isDutQa(dev);
}
